module.exports = __webpack_public_path__ + "static/media/link-logo-mexder.fde87586.png";